import { useEffect } from 'react'
import { AdsRegisterPanel } from './AdsRegisterPanel'
import { portalLinks } from '../portal-links'
import './gold-direction-landing.css'

/** Paid / creative landing: left creative + right register panel. */
export function GoldDirectionLandingPage() {
  useEffect(() => {
    document.title = 'Perfect Predict | Trade gold direction'
    let robots = document.querySelector('meta[name="robots"]')
    if (!robots) {
      robots = document.createElement('meta')
      robots.setAttribute('name', 'robots')
      document.head.appendChild(robots)
    }
    robots.setAttribute('content', 'noindex, nofollow')
  }, [])

  return (
    <div className="ads-gold">
      <div className="ads-gold__glow" aria-hidden="true" />
      <div className="ads-gold__wrap">
        <main className="ads-gold__main">
          <div className="ads-gold__visual-wrap">
            <img
              className="ads-gold__visual"
              src="/ads/gold-direction-hero.png"
              alt="Perfect Predict — trade gold market direction with a structured ticket"
              width={1200}
              height={675}
            />
          </div>

          <ul className="ads-gold__points">
            <li style={{ ['--i' as string]: 0 }}>
              <i aria-hidden="true">◎</i>
              Trade short-term market direction
            </li>
            <li style={{ ['--i' as string]: 1 }}>
              <i aria-hidden="true">✓</i>
              Structured setup for risk control
            </li>
            <li style={{ ['--i' as string]: 2 }}>
              <i aria-hidden="true">▤</i>
              Stay focused. Trade with clarity.
            </li>
          </ul>

          <p className="ads-gold__risk">Trading involves risk. No guaranteed returns.</p>
          <p className="ads-gold__fallback">
            Need the full form? <a href={portalLinks.register}>Register here</a>
          </p>
        </main>

        <AdsRegisterPanel />
      </div>
    </div>
  )
}
